/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c12f80c2cd866bb84646bb680fc8359425f7c512";
